var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"el",staticClass:"loader-box",class:_vm.loading ? null : 'content-loaded'},[(_vm.animate)?_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"double-bounce1",style:(`background-color: ${_vm.colorA}`)}),_c('div',{staticClass:"double-bounce2",style:(`background-color: ${_vm.colorB}`)})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }